import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as PaymentsConstants from '../../constants';
import * as D from '../../deps';

import './CancelLink.scss';

const CancelLink = ({ isBackgroundLight, isBlueUrl, useInstructionsMessage }) => {
  const classNames = D.createBEM('CancelLink', {
    lightBackground: isBackgroundLight,
    blue: isBlueUrl,
  });

  const message = useInstructionsMessage
    ? PaymentsConstants.Messages.agreementCancelInstructions
    : PaymentsConstants.Messages.agreementCancel;

  return (
    <a className={classNames} href={D.Utils.Route.getCancelUrl()} target='_blank' rel='noreferrer'>
      <FormattedMessage {...message} />
    </a>
  );
};

CancelLink.propTypes = {
  isBackgroundLight: PropTypes.bool,
  isBlueUrl: PropTypes.bool,
  useInstructionsMessage: PropTypes.bool,
};

export default CancelLink;
